import * as React from "react";
import {Platform} from "@variocube/app-api";
import {EventSupportingApp} from "@variocube/app-common";
import {AppContext, AppErrorBoundary, ThemeProvider} from "@variocube/cube-ui";
import {render} from "react-dom";
import icon from "./delivery.svg";
import {App} from "./app";
import {Tenant} from "./types";
import {LocalizationProvider, SUPPORTED_LANGUAGES} from "../i18n";

export default class RentalApp extends EventSupportingApp {

    constructor(p: Platform) {
        super(p, icon, "#4CAF50", SUPPORTED_LANGUAGES);
    }

    render(root: Element) {
        const appContext = {
            platform: this.platform,
            appEventSupport: this.eventSupport
        };
        const defaultTheme = {
            colorBackground: "#DBDBDB",
            colorForeground: "#333333",
            colorPrimary: "#4CAF50",
            colorSeparator: "#B4BD48",
            colorInputBackground: "#fff",
        }
        render((
            <AppContext.Provider value={appContext}>
                <ThemeProvider defaultTheme={defaultTheme}>
                    <LocalizationProvider app={this}>
                        <AppErrorBoundary appId={this.platform.appId} cubeId={this.platform.hostname}>
                            <App/>
                        </AppErrorBoundary>
                    </LocalizationProvider>
                </ThemeProvider>
            </AppContext.Provider>
        ), root);
    }

    async loadMockData() {

        const background = this.platform.getArg("background");

        let backgroundImage = undefined;
        if (background) {
            const backgroundResponse = await window.fetch("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mPccePjfwAIUwOCOf5cIwAAAABJRU5ErkJggg==");
            backgroundImage = await backgroundResponse.blob();
        }

        return {
            backgroundImage,
            tenant: {
                name: "VSP - Waste Management",
                user: "Bernt",
                adminCode: "999"
            },
            plasticBagBoxes: [ "1", "3", "5" ],
            plasticBagBoxes2Rolls: [ "10" ],
            bigBagBoxes: [ "2", "4", "6" ],
            wasteBoxes: [ "9" ]
        } as MockData;
    }
}

interface MockData {
    tenant: Tenant;
    plasticBagBoxes: string[];
    plasticBagBoxes2Rolls: string[];
    bigBagBoxes: string[];
    wasteBoxes: string[];
}
